import { ReactNode } from "react";
import { clarity } from "react-microsoft-clarity";

interface ClarityProviderProps {
    children: ReactNode;
}

export function ClarityProvider(props: ClarityProviderProps) {
    const { children } = props;

    if (import.meta.env.MODE === "production" || import.meta.env.MODE === "staging") {
        clarity.init(import.meta.env.VITE_CLARITY_ID);
    }

    return <>{children}</>;
}
